import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { session_id_beg, session_id_end, copyToClipboard } from "../../../../../utils/helpers";
import CopyComponent from "../../../../../components/copyComponent";

var avatarPalettes = [
  { background: '#f5e6d8', color: '#b87040' },
  { background: '#faf0e8', color: '#c07838' },
  { background: '#eeddd0', color: '#a86030' },
  { background: '#f7ece0', color: '#d5a67b' },
  { background: '#f0e0cc', color: '#b87848' },
];
function getInitials(name) {
  if (!name) return '?';
  var parts = name.trim().split(' ').filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
}
function getAvatarStyle(name) {
  var idx = name ? name.charCodeAt(0) % avatarPalettes.length : 0;
  return Object.assign({}, avatarPalettes[idx], {
    width: 54, height: 54, borderRadius: '50%',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontWeight: '700', fontSize: '18px', flexShrink: 0,
  });
}

export default function NoshowBox({
  noShowActive,
  list = [],
  noShowRequest,
  noshowRemoveGroupAppointment,
  noshowFrom,
  refundAttendee
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [emailsCopied, setEmailsCopied] = useState(false);

  useEffect(() => {
    console.log(list, "list");
    console.log(noShowActive, "noShowActive");
  }, [list]);

  const filteredList = list.filter(item =>
    item.client &&
    item.client.screen_name &&
    item.client.screen_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Copies every attendee email currently visible in the popup, skipping
  // status 2 (No Show) and status 3 (Removed), comma-separated.
  const copyAllEmails = () => {
    const emails = filteredList
      .filter((item) => item.status !== 2 && item.status !== 3)
      .map((item) => item.client && item.client.email)
      .filter(Boolean);

    if (emails.length === 0) return;

    copyToClipboard(emails.join(", "));
    setEmailsCopied(true);
    setTimeout(() => setEmailsCopied(false), 3000);
  };

  // "Copy Attendee's Emails" is only time-limited for Mediums: it stops
  // showing 2 days after the session date. Admins keep it indefinitely.
  const COPY_EMAILS_EXPIRY_DAYS = 2;
  const authRole = useSelector((state) => state.auth && state.auth.role);
  const isMedium = authRole === "medium";

  const isCopyEmailsExpired = () => {
    if (!isMedium) return false;

    const rawDate = noShowActive && noShowActive.date;
    if (!rawDate) return false;

    const sessionDate = new Date(String(rawDate).split(" ")[0]);
    if (Number.isNaN(sessionDate.getTime())) return false;

    const expiresAt = new Date(sessionDate);
    expiresAt.setDate(expiresAt.getDate() + COPY_EMAILS_EXPIRY_DAYS);
    expiresAt.setHours(23, 59, 59, 999);

    return new Date() > expiresAt;
  };

  const copyEmailsExpired = isCopyEmailsExpired();

  return (
    <div className="register-medium">
      <div
        className="modal fade"
        id="NoshowBox"
        role="dialog"
      >
        <div className="width-unset modal-dialog advanceConfirmbooking modal-lg modal-dialog-preview height-unset">
          <div className="modal-content p-5">
            <div className="modal-body">
              <div className="schedule-popup">
                <h3 className="mb-4 mt-2 text-center">
                  Attendees For{" "}
                  {noShowActive !== undefined &&
                    `${session_id_beg}${noShowActive.id}${session_id_end}`}
                </h3>

                {/* Copy every visible attendee's email (excluding No Show / Removed).
                    Hidden for Mediums once the session is more than 2 days old. */}
                {!copyEmailsExpired && (
                  <button
                    type="button"
                    className="copy-attendee-emails-btn"
                    onClick={copyAllEmails}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="9" y="9" width="11" height="11" rx="2"></rect>
                      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    {emailsCopied ? "Copied!" : "Copy Attendee's Emails"}
                  </button>
                )}

                {/* 🔍 Search Input */}
                <input
                  type="text"
                  className="mb-4 mt-2 text-center attendees-search-input"
                  placeholder="Search name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="now-show-box-wrapper">
                  
                  {filteredList.length > 0 ? (
                    filteredList.map((item, index) => (
                      <div
                        key={index}
                        className={`profilecard-wrapper justify-content-between pointer w-90 ${item.session_type == 35 && item.client.usertype == 3 ? "green-border" : ""}`}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <div className="profile-photo" style={{ flexShrink: 0, width: 54, height: 54, borderRadius: '50%', overflow: 'hidden' }}>
                            {item.client.profile_image ? (
                              <img
                                width="100%"
                                height="100%"
                                style={{ objectFit: 'cover', display: 'block' }}
                                src={`${process.env.REACT_APP_IMAGE_URL}${item.client.profile_image}`}
                                alt="Profile"
                              />
                            ) : (
                              <div style={getAvatarStyle(item.client.screen_name)}>
                                {getInitials(item.client.screen_name)}
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.4', textAlign: 'left' }}>
                            <span style={{ fontSize: '16px', fontWeight: '600', color: '#485257' }}>{item.client.screen_name}</span>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', fontSize: '13px', color: '#888', marginTop: '2px' }}>
                              {item.client.email}
                              <CopyComponent value={item.client.email} />
                            </span>
                            {item.payment_status === "Refunding" && (
                              <span style={{ fontSize: '12px', fontWeight: '600', color: '#d5a67b', marginTop: '2px' }}>
                                {item.payment_status}
                              </span>
                            )}
                          </div>
                        </div>
                        <div>
                          {item.status === 0 || item.status === 1 ? (
                            <>
                              {noshowFrom === "remove" && (
                                <div
                                  className="margin-unset register-medium-confirnation appointment-no-show-card"
                                  onClick={() =>
                                    noshowRemoveGroupAppointment(item)
                                  }
                                  data-dismiss="modal"
                                >
                                  Remove
                                </div>
                              )}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <div
                                className="margin-unset register-medium-confirnation appointment-no-show-card"
                                onClick={() => noShowRequest(item)}
                                data-dismiss="modal"
                              >
                                No Show
                              </div>
                              {/* Refund acts on this attendee's own paid
                                  transaction, same as the 1:1 refund flow.
                                  There's no "Waive" here: group sessions are
                                  pay-to-book, so every attendee row has
                                  already paid in full — an attendee can only
                                  ever be Paid or already Refunding, never
                                  "Attempted" (unpaid), so waiving a payment
                                  that was never left outstanding doesn't
                                  apply to this list. */}
                              {refundAttendee && item.payment_status === "Paid" && (
                                <>
                                  &nbsp;&nbsp;&nbsp;&nbsp;
                                  <div
                                    className="margin-unset register-medium-confirnation appointment-no-show-card"
                                    onClick={() => refundAttendee(item)}
                                    data-dismiss="modal"
                                  >
                                    Refund
                                  </div>
                                </>
                              )}
                            </>
                          ) : (
                            <span>
                              <b>
                                {item.status === 2
                                  ? `No Show by ${item.userbyName} at ${item.userbyDate}`
                                  : item.status === 3
                                  ? `Removed by ${item.userbyName} at ${item.userbyDate}`
                                  : ""}
                              </b>
                            </span>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No matching attendees found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
